<div class="frame-container" [class.shown]="option!=''">
  <div class="header">
    <button (click)="clickBack()">
      <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M83.333 59.5117H34.9997M52.1544 40L33.333 59.5117L52.1544 79.0237" stroke="#001134" stroke-width="4"
          stroke-linecap="round" />
      </svg>
    </button>
    <div class="date-time">
      <app-datetoday></app-datetoday>
    </div>
  </div>


  <app-country *ngIf="option=='country'"></app-country>

  <div class="main-content row top-xs center-xs pt-0" *ngIf="option=='custom'">
    <div class="col-xs-12" style="margin: 0;">
      <div class="text" style="margin: 1rem 0;"><span style="padding-bottom:100px;font-weight: bolder;">Please select an
          option</span></div>
      <div class="search">
        <input type="text" class="bg-search col-xs-12" placeholder="Search" [value]="keyword" (change)="updateKeyword($event)" />
      </div>
      <!-- <ng-scrollbar class="custom-scrollbar" style="height: 100%" [pointerEventsDisabled]="false" visibility="always"> -->
        <div class="tab-content-wrapper">
          <table style="margin: 1rem auto;width:100%;">
            <tr *ngFor="let option of filteredOptions" (click)="select_option(option)" style="margin-bottom:10px;">
              <td style="padding:30px;">
                <div style="font-weight: bold;" [innerHTML]="option.display"></div>
              </td>
            </tr>
          </table>
        </div>
      <!-- </ng-scrollbar> -->
    </div>
  </div>

  <!-- <app-country *ngIf="option=='country'"></app-country> -->
</div>
